// extracted by mini-css-extract-plugin
export default {"container":"ProgramPage_container__TzW3u"};